import union from 'lodash-es/union';
import curry from 'lodash-es/curry';

import { Dictionary, DictionaryEntry } from 'app/services/dict.service';

const getPreparedValue = (value: string | number | boolean) =>
  value.toString().toLowerCase();

const includesValue = (inputValue: string, definition: DictionaryEntry) =>
  getPreparedValue(definition.value).includes(inputValue.toLowerCase());

const startsWithValue = (inputValue: string, definition: DictionaryEntry) =>
  getPreparedValue(definition.value).startsWith(inputValue.toLowerCase());

export const getSuggestions = (
  dictionary: Dictionary,
  inputValue: string | null
) => {
  if (!inputValue) {
    return dictionary;
  }

  const valueStartsWith = dictionary.filter(curry(startsWithValue)(inputValue));
  const withIncludes = dictionary.filter(curry(includesValue)(inputValue));

  return union(valueStartsWith, withIncludes);
};
